import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormFlex } from '../../legacy/components';
import { useAppImage } from '../../legacy/hooks';
import { styled } from '../../legacy/utils';
import { HeaderContents } from './HeaderContents';
export const Header = (props) => {
    const { logoDesktop, logoDesktopWidth, logoMobile, contents } = props;
    const AppImage = useAppImage();
    return (_jsxs(HeaderWrapperStyled, { rowGap: 0, columnGap: 0, children: [_jsx(HeaderContents, { contents: contents }), _jsxs(FormFlex, { rowGap: 0, columnGap: 0, children: [_jsx(LogoDesktopStyled, { children: _jsx(AppImage, { alt: "logo", src: logoDesktop, width: logoDesktopWidth ?? 133, height: 32 }) }), _jsx(LogoMobileStyled, { sx: { padding: '4px 0' }, children: _jsx(AppImage, { alt: "logomobile", src: logoMobile, width: 32, height: 32 }) })] })] }));
};
const HeaderWrapperStyled = styled(FormFlex)(({ theme }) => ({
    padding: theme.spacing(106),
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'nowrap',
    zIndex: theme.zIndex.appBar,
    borderBottom: `1px solid ${theme.palette.groupPrimary.lightDove}`,
    position: 'sticky',
    top: 0,
    backgroundColor: theme.palette.primary.contrastText,
    [theme.breakpoints.down('md')]: {
        padding: theme.spacing(102, 105),
    },
}));
const LogoDesktopStyled = styled('div')(({ theme }) => ({
    display: 'flex',
    [theme.breakpoints.down('lg')]: {
        display: 'none',
    },
}));
const LogoMobileStyled = styled('div')(({ theme }) => ({
    display: 'flex',
    [theme.breakpoints.up('lg')]: {
        display: 'none',
    },
}));
